<template>
  <ChatComponent
    :current-user-id="user.id"
    :rooms="rooms"
    :rooms-loaded="roomsLoaded"
  ></ChatComponent>
</template>

<script>
import ChatComponent from '../../components/chat/ChatComponent'
import { mapGetters } from 'vuex'
export default {
  name: 'Chats',
  components: { ChatComponent },
  data () {
    return {
      roomsLoaded: false,
      rooms: []
    }
  },
  computed: {
    ...mapGetters({
      user: 'userAuth/user'
    })
  },
  created () {
    this.roomsLoaded = false
    this.$http.get(`users/${this.user.id}/chats`)
      .then(res => {
        this.rooms = res.data.map(room => {
          room.roomId = room.id
          room.roomName = `Poptávka č. ${room.demandId}`

          room.user._id = room.user.id
          room.user.username = room.user.email
          room.host._id = room.host.id
          room.host.username = `${room.host.firstName} ${room.host.lastName}`
          room.users = [room.user, room.host]
          return room
        })

        this.roomsLoaded = true
      })
  }
}
</script>

<style scoped>

</style>
